var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    ("cv-content-switcher " + _vm.carbonPrefix + "--content-switcher"),
    ( _obj = {}, _obj[(_vm.carbonPrefix + "--content-switcher--light")] = _vm.isLight, _obj[(_vm.carbonPrefix + "--content-switcher--" + _vm.size)] = _vm.size, _obj ) ],attrs:{"data-content-switcher":"","role":"tablist"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }